import { useUserStore } from '@/store/UserStore';
import { request } from '../request';


export type InputGetAccountList = {
  Phone?: string;
  NickName?: string;
  Email?:string;
  Uid?: string;
  StartTime?: number;
  EndTime?: number;
};


/**
 * 获取账号数据列表
 * @param page
 * @param pageSize
 * @param input
 * @returns
 */
export function fetchGetAccountListAsync(page: number, pageSize: number, input: InputGetAccountList) {
  return request<{
    total: number,
    list: DB.User[]
  }>({
    url: '/User/GetAccountList',
    method: 'post',
    data: input,
    params: {
      page,
      pageSize
    }
  });
}

/**
 * 获取用户登录数据
 */
export async function fetchGetUserDataForUser(){
  const resp = await request<DB.User>({
    url: '/User/GetUserDataForUser',
    method: 'get',
  });
  return resp;
}

